import { adminApi } from '~/api'
import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { type ApiQueryResult } from '~/utils/types'
import { type Registration, type Course } from '~/types/course'

export const useCourseQuery = (id: number): UseQueryResult<Course> =>
  useQuery({
    queryKey: ['courses', id],
    queryFn: async () => {
      const { data } = await adminApi.getCourse(id)
      return data.data
    }
  })

export const useCourseAttachmentsQuery = (id: number): ApiQueryResult =>
  useQuery({
    queryKey: ['courses_attachments', id],
    queryFn: async () => {
      const { data } = await adminApi.getCourseAttachments(id)
      return data.data
    }
  })

export const useWaitlistsQuery = (params: {
  course_id: number
  search?: string
  per_page?: number
}): UseQueryResult<Registration[]> =>
  useQuery({
    queryKey: ['waitlists', params],
    queryFn: async () => {
      const { data } = await adminApi.getWaitlists(params)
      return data.data
    }
  })
